
export const Path = {
    login: "/login",
    home: "/home"
    // changepass: "/changepass",
    // resetpass: "/resetpass",
}
